import * as ContentBodyClasses from './index';

export function getContentBodyConstructorFrom(type) {
	return Object.values(ContentBodyClasses).find(content => content.CONTENT_TYPE === type);
}

export function getContentUploadMethod(type) {
	return Object.values(ContentBodyClasses).find(content => content.BULK_UPLOAD && content.CONTENT_TYPE === type).BULK_UPLOAD
		.method;
}

export function getContentBulkUploadOptions(type) {
	return Object.values(ContentBodyClasses).find(content => content.BULK_UPLOAD && content.CONTENT_TYPE === type).BULK_UPLOAD;
}

export function getContentAllowedExtensions(type) {
	return getContentBodyConstructorFrom(type).BULK_UPLOAD.extensions;
}

export function getAllContentBodyTypes() {
	return Object.values(ContentBodyClasses).map(content => content.CONTENT_TYPE);
}
